document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll('.sbc-section');


  sections.forEach(function (section) {

    const tabs = section.querySelectorAll('.sbc-tab');

    const tabItems = section.querySelectorAll('.sbc-tab-item');

    const desktopImages = section.querySelectorAll('.sbc-image-wrapper');


    /* =========================================
       TAB CLICK
    ========================================= */

    tabs.forEach(function (tab) {

      tab.addEventListener('click', function () {

        const index = this.getAttribute('data-tab');


        /* -----------------------------------------
           REMOVE ACTIVE FROM TABS
        ----------------------------------------- */

        tabs.forEach(function (item) {

          item.classList.remove('active');

          item.setAttribute(
            'aria-selected',
            'false'
          );

        });


        /* -----------------------------------------
           REMOVE ACTIVE FROM TAB ITEMS
        ----------------------------------------- */

        tabItems.forEach(function (item) {

          item.classList.remove('active');

        });


        /* -----------------------------------------
           REMOVE ACTIVE FROM DESKTOP IMAGES
        ----------------------------------------- */

        desktopImages.forEach(function (image) {

          image.classList.remove('active');

        });


        /* -----------------------------------------
           ACTIVE CLICKED TAB
        ----------------------------------------- */

        this.classList.add('active');

        this.setAttribute(
          'aria-selected',
          'true'
        );


        /* -----------------------------------------
           ACTIVE TAB ITEM
        ----------------------------------------- */

        const activeItem = section.querySelector(
          '.sbc-tab-item[data-tab-item="' + index + '"]'
        );


        if (activeItem) {

          activeItem.classList.add('active');

        }


        /* -----------------------------------------
           DESKTOP IMAGE
        ----------------------------------------- */

        const activeDesktopImage = section.querySelector(
          '.sbc-image-wrapper[data-image="' + index + '"]'
        );


        if (activeDesktopImage) {

          activeDesktopImage.classList.add('active');

        }


      });

    });

  });

});